<!-- <form [formGroup]="createClientForm" (ngSubmit)="createClient()" #form="ngForm">
  <mat-form-field class="form-field" appearance="outline">
    <mat-label>First Name</mat-label>
    <input formControlName="firstName" />
    <mat-error *ngIf="hasError('firstName', 'required')"
      >Field is required</mat-error
    >
  </mat-form-field>

  <mat-form-field class="form-field" appearance="outline">
    <mat-label>Last Name</mat-label>
    <input formControlName="lastName" />
    <mat-error *ngIf="hasError('lastName', 'required')"
      >Field is required</mat-error
    >
  </mat-form-field>

  <button color="primary" type="submit" [disabled]="createClientForm.invalid">
    Create Client
  </button>
</form> -->
Create client
